// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"2722c4a7","571":"82441990","664":"ee45652d","704":"9807b04a","801":"16c2874a","839":"db62a4dd","845":"99cab66c","925":"25a75f95"}[chunkId] + ".chunk.js";
};